import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';
import SVGLoader from './SVGLoader';
import './index.scss';
import useTranslationInfo from '../utils/useTranslationInfo';
import { translationPerformanceKeys } from '../utils/performance';

export const LONG_LOADING_DELAY_MS = 2000;

const TranslationsLoader = ({ courseId, defaultLoaderComponent }) => {
  const { formatMessage } = useIntl();
  const { isTranslating } = useTranslationInfo(courseId);
  const [showAdditionalMessage, setShowAdditionalMessage] = useState(false);

  useEffect(() => {
    window.performance?.mark?.(translationPerformanceKeys.loadKey);
  }, []);

  useEffect(() => {
    if (isTranslating) {
      const timer = setTimeout(() => {
        setShowAdditionalMessage(true);
      }, LONG_LOADING_DELAY_MS);

      return () => clearTimeout(timer);
    }
    return undefined; // to remove linting error
  }, [isTranslating]);

  return isTranslating ? (
    <div
      className="d-flex justify-content-center align-items-center flex-column"
      id="translating-loader-container"
    >
      <SVGLoader />
      <p className="mt-2" id="loader-text">
        {formatMessage(messages.translatingLoaderText)}
        <span className="ellipsis-container">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </p>
      {showAdditionalMessage && (
        <p className="mt-2" id="additional-message">
          {formatMessage(messages.translatingLoaderAdditionalTextFirstLine)} <br />
          {formatMessage(messages.translatingLoaderAdditionalTextWaitNote)}
        </p>
      )}
    </div>
  ) : (
    defaultLoaderComponent
  );
};

TranslationsLoader.propTypes = {
  courseId: PropTypes.string.isRequired,
  defaultLoaderComponent: PropTypes.node.isRequired,
};

export default TranslationsLoader;
